import { Directive, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';

@Directive()
export class LogoutButtonAbstract {
    /**
     * Logout action status
     */
    logoutStatus = new Status();

    /**
     * Auth service
     */

    private request = inject(RequestService);

    logout() {
        this.request.send(this.logoutStatus, () => this.request.nexus.customer.logout({}));
    }
}
